import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => {
    return {
        title: {
            fontSize: theme.px2rem(14),
            marginBottom: theme.spacing(2),
            fontWeight: 500,
            paddingLeft: theme.spacing(1),
            color: theme.black.black65,
        },
        chipContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            '& > *': {
                margin: theme.spacing(1),
            },
            marginBottom: theme.spacing(1),
        },
        chip: {
            flex: '1 0 21%',
        },
        marginBottom: {
            marginBottom: theme.spacing(3),
        },
        marginTop: {
            marginTop: theme.spacing(3),
        },
        customBlock: {
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: theme.black.black5,
            justifyContent: 'space-between',
        },
        customControlNumber: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(1),
            fontSize: theme.px2rem(18),
            color: theme.black.black65,
            fontWeight: 500,
            borderTop: `1px solid ${theme.black.black65}`,
            borderBottom: `1px solid ${theme.black.black65}`,
            width: theme.px2rem(60),
            transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
        customControlButton: {
            padding: 0,
            color: theme.black.black65,
            border: `1px solid ${theme.black.black65}`,
            borderRadius: 0,
            minWidth: theme.px2rem(60),
        },
        customControlButtonDisabled: {
            backgroundColor: theme.palette.action.disabledBackground,
        },
        customSelect: {
            width: '100%',
        },
        customSelectRoot: {
            backgroundColor: 'transparent',
            borderRadius: 0,
        },
        couponLine: {
            padding: `${theme.px2rem(10)} 0`,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        coupon: {
            fontSize: theme.px2rem(14),
            color: '#2196F3',
            textTransform: 'none',
        },
        couponSum: {
            fontSize: theme.px2rem(16),
            color: '#000000',
            fontWeight: 500,
        },
        couponInputWrapper: {
            backgroundColor: '#F5F5F5',
            border: '1px solid #D2D3D3',
            borderRadius: '8px',
            display: 'flex',
            width: '50%',
            justifyContent: 'space-between',
        },
        couponInput: {
            fontSize: theme.px2rem(14),
            color: theme.black.black65,
            padding: `0 ${theme.px2rem(5)}`,
        },
        couponInputWithText: {
            backgroundColor: '#FFF',
        },
        applyCoupon: {
            color: theme.black.black100,
        },
        chipCoupon: {
            backgroundColor: '#E9840E',
            filter: 'brightness(135%)',
            color: '#FFF',
        },
        receipt: {
            padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
            backgroundColor: '#EAF9FA',
            borderRadius: '12px',
            marginTop: theme.spacing(2),
        },
        receiptSectionHeader: {
            color: '#828282',
            fontWeight: 500,
            fontSize: theme.px2rem(14),
            marginBottom: theme.spacing(1),
        },
        receiptData: {
            color: '#000000',
            fontWeight: 500,
            fontSize: theme.px2rem(16),
        },
        divider: {
            margin: `${theme.spacing(2)} 0`,
            color: '#828282',
        },
        total: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(4),
        },
        note: {
            color: theme.black.black65,
            fontSize: theme.px2rem(12),
        },
        marginBottom2: {
            paddingBottom: theme.spacing(2),
        },
        rotatedSwitch: {
            transform: 'rotate(180deg)',
        },
    };
}, { name: 'dz-pre-sold-dialog', index: 0 });
